import React from 'react';

import '../styles/ResponsivePicture.css';
/**
 * ResponsivePicture Component
 *
 * Renders a <picture> element with multiple <source> tags for different breakpoints.
 *
 * Props:
 * - backgroundSrc: Fallback image URL.
 * - backgroundImages: Optional object with URLs for different breakpoints:
 *     - small: Up to 600px wide.
 *     - medium: 601px to 1024px wide.
 *     - large: 1025px and wider.
 * - pictureClassName: Optional CSS class for the <picture> element.
 * - imgClassName: Optional CSS class for the fallback <img> element.
 * - alt: Optional alt text.
 */
const ResponsivePicture = ({
  backgroundSrc,
  backgroundImages,
  alt,
  pictureClassName = 'masthead__picture',
  imgClassName = 'masthead__img',
}) => (
  <picture className={pictureClassName}>
    {backgroundImages?.small && (
      <source media="(max-width: 600px)" srcSet={backgroundImages.small} />
    )}
    {backgroundImages?.medium && (
      <source media="(min-width: 601px) and (max-width: 1200px)" srcSet={backgroundImages.medium} />
    )}
    {backgroundImages?.large && (
      <source media="(min-width: 1201px)" srcSet={backgroundImages.large} />
    )}
    {/* Fallback image */}
    <img src={backgroundSrc} alt={alt || 'Masthead Background'} className={imgClassName} />
  </picture>
);

export default ResponsivePicture;
